import G6 from '@antv/g6-pc';
G6.version = '4.8.23';
export * from '@antv/g6-pc';
export default G6;
export var version = '4.8.23';


//////////////////
// WEBPACK FOOTER
// ./node_modules/@antv/g6/es/index.js
// module id = null
// module chunks = 